import styled from "styled-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(FlexColumn)`
    gap: 4px;
`;
